import GeneratedQueryResultServiceApi from "./generated/GeneratedQueryResultServiceApi"

class QueryResultServiceApi extends GeneratedQueryResultServiceApi {

}

export const queryResultServiceApi = new QueryResultServiceApi()
